import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "exponent-participation-request-answer" as const;

export type ExponentParticipationRequestAnswerEventData = {
  eventId: string;
  structureId: string;
  isAccepted: boolean;
};
export type ExponentParticipationRequestAnswerEvent = AppEvent<
  typeof eventName,
  ExponentParticipationRequestAnswerEventData
>;

export const isExponentParticipationRequestAnswerEvent = (
  event: AnyAppEvent
): event is ExponentParticipationRequestAnswerEvent => event.name === eventName;

export { eventName as exponentParticipationRequestAnswer };
